module.exports = __webpack_public_path__ + "img/logo.d3f6b6df.svg";